import {isEmpty, isInteger} from 'lodash';
import isDecimal from 'validator/lib/isDecimal';
import isNumeric from 'validator/lib/isNumeric';
import i18n from "../../../i18n";
import moment from 'moment'

export const validate = values => {
    let errors = {};

    startDate(values, errors);
    endDate(values, errors);
    vehicleCount(values, errors);
    //price(values, errors);
    comment(values, errors);

    return errors;
};

const startDate = (values, errors) => {
    if (isEmpty(values.startDate)) {
        return errors.startDate = "Vous devez indiquer la date de début de stationnement";
    }
    if (moment(values.startDate) <= moment()) {
        return errors.startDate = i18n.t('booking.validation_invalid_date');
    }
};

const endDate = (values, errors) => {
    if (isEmpty(values.endDate)) {
        return errors.endDate = "Vous devez indiquer la date de fin de stationnement";
    }
};

const vehicleCount = (values, errors) => {
    if (!isInteger(values.vehicleCount) || values.vehicleCount <= 0) {
        return errors.bags = "Le nombre de véhicules doit être un nombre supérieur à 0";
    }
};

const comment = (values, errors) => {
    if (isEmpty(values.comment)) {
        return errors.comment = "Le modèle du véhicule est obligatoire";
    }
};

const price = (values, errors) => {
    if (isEmpty(values.price)) {
        return errors.price = "Le montant est obligatoire";
    }

    if (!isDecimal(values.price)) {
        return errors.price = "Le montant doit être un nombre";
    }

};
